// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__yEdaU","modal":"Modal_modal__RnPaL","header":"Modal_header__sPgxa","close":"Modal_close__gGob1","body":"Modal_body__sbS08"};